
    <div class="dropdown__spinner" *ngIf="isLoading"><kpd-spinner></kpd-spinner></div>
    <div class="header__menu flex-row" (click)="$event.preventDefault(); $event.stopPropagation()">
      <input
        [(ngModel)]="searchInput"
        (ngModelChange)="searchTenants()"
        style="margin-left: 12px"
        [placeholder]="'Search' | translate"
      />
    </div>
    <div class="header__menu flex-row" *ngFor="let tenant of filteredTenants">
      <button class="dropdown--menu__item" (click)="onTenantSelected(tenant)" translate>
        <div class="radio-button">
          <input type="radio" name="radio" [checked]="tenant.name === tenantName" />
          <span class="radio-button__circle"></span>
          <span class="radio-button__label">
            {{ tenant.description }}
          </span>
        </div>
      </button>
    </div>
  